import type { ReactNode } from 'react';
import { RequiredMark } from './RequiredMark';

interface LabelTextProps {
  isRequired?: boolean | undefined;
  children: ReactNode;
}

export function LabelText({ isRequired = false, children }: LabelTextProps) {
  return (
    <span>
      {children}
      {isRequired ? <RequiredMark /> : null}
    </span>
  );
}
